import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Card, CardBody } from "reactstrap";
import IntlMessages from 'util/IntlMessages';

class NoAccessPage extends React.Component {

  render() {
    return (
      <div className="app-wrapper">
        <Card className="border-0">
          <CardBody>
            <Typography component="h2" variant="h5" gutterBottom>
              <IntlMessages id="pages.noAccess"/>
            </Typography>
            <div>
              <IntlMessages id="pages.noAccess.description"/>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default NoAccessPage;